module.exports = __webpack_public_path__ + "static/media/MNN_Web_logo.3b01309f.png";